import { useEffect } from 'react'

import Cookies from 'js-cookie'

import { getDomainName, PINTEREST_COOKIE_KEY } from './utils'

function getEpikFromQuery() {
  const params = new URLSearchParams(window.location.search)
  return params.get('epik')
}

export default function usePinterestCookie() {
  useEffect(() => {
    if (typeof window === 'undefined') return

    const queryEpikValue = getEpikFromQuery()
    if (!queryEpikValue) return

    const currentValue = Cookies.get(PINTEREST_COOKIE_KEY)
    if (currentValue !== queryEpikValue) {
      const domain = getDomainName()
      const path = '/'
      const expires = 365
      Cookies.set(PINTEREST_COOKIE_KEY, queryEpikValue, { domain, path, expires })
    }
  }, [])
}
